export default "__VITE_ASSET__D5lb2thX__"